import { SEND_TIME_TRACKING, SEND_EVENT_TRACKING } from "../actions/trackingEvents"
import {middlewareWrapper} from "utils/middlewareUtils"

export default (googleTracking, omnitureTracking, config) => {

    const { omniture: omnitureConfig = null, google: googleConfig = null } = config.metricsVendors;
    if (!omnitureConfig || !googleConfig) {
        throw new Error('missing third party metric configs');
    }

    const googleClient = new googleTracking(googleConfig)

    return [
        middlewareWrapper(thirdPartyTimeTrackingEvents),
        middlewareWrapper(thirdPartyEventTracking)
    ]


    function thirdPartyTimeTrackingEvents(store, next, action) {
        if (action.type === SEND_TIME_TRACKING) {
            const { times = null, category = null, metric = null, label = null } = action.data
            if (!times || !category || !metric || !label) {
                return next(action);
            }

            times.forEach(time => {
                googleClient.sendTracking('timing', {
                    timingCategory: category,
                    timingVar: metric,
                    timingValue: time,
                    timingLabel: label
                })
            });
        }
        return next(action)
    }

    function thirdPartyEventTracking(store, next, action) {
        if (action.type === SEND_EVENT_TRACKING) {
            const { category: eventCategory = null, eventAction = null, value: eventValue = null } = action.data
            if (!eventCategory || !eventAction) {
                return next(action)
            }
            const event = {
                eventCategory,
                eventAction
            }
            if (eventValue) {
                event.eventValue = eventValue
            }

            googleClient.sendTracking('event', event)
        }
        return next(action)
    }

}


// WEBPACK FOOTER //
// ./modules/Common/middleware/trackingEvents.js